export enum PaidStatus{

    Paid = "Paid",
    Unpaid = "Unpaid",
    Pending = "Pending",
    NoCharge = "NoCharge"

}
